import { Button, Col, Form, Input, message, Row, Tabs, Statistic } from 'antd';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { resetMobileCodeApi, resetMailCodeApi, resetMobileApi, resetMailApi } from '../api';
import { language } from '../language';
import '../index.less';

const formItemLayout = { labelCol: { span: 6 }, wrapperCol: { span: 18 } };
const tailFormItemLayout = { wrapperCol: { span: 24 } };

const Retrieve = () => {
  const [isSendVerifyCode, setIsSendVerifyCode] = useState(false);
  const [form] = Form.useForm();
  const account = Form.useWatch('account', form);
  const email_account = Form.useWatch('email_account', form);
  const history = useHistory();
  const $t = (key) => language.zh[key] || key;
  const [tabsId, setTabsId] = useState('1');

  const items = [{ label: $t('Tel Account'), key: '1' }, { label: $t('Email Account'), key: '2' }];

  const onFinish = async (values) => {
    const apiOptions = {
      '1': () => {
        return resetMobileApi(values);
      },
      '2': () => {
        return resetMailApi(values);
      }
    };
    const { data: { code, msg } } = await apiOptions[`${tabsId}`]?.();
    if (code === 0) {
      message.success(msg);
      history.push('/login');
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onTabsChange = (activeKey) => {
    setTabsId(activeKey);
    form.resetFields();
    setIsSendVerifyCode(false);
  };

  const getRetrieveCode = async () => {
    try {
      const apiOptions = {
        '1': async () => {
          await form.validateFields(['account']);
          return resetMobileCodeApi({ account });
        },
        '2': async () => {
          await form.validateFields(['email_account']);
          return resetMailCodeApi({ email_account });
        }
      };
      const { data: { code } } = await apiOptions[`${tabsId}`]?.();
      if (+code === 0) {
        message.info($t('The verification code has been sent and is valid within 10 minutes'));
        setIsSendVerifyCode(true);
      }
    } catch (error) {
      console.log('getRetrieveCode ~ error:', error);
    }
  };

  const countDownFinish = () => {
    setIsSendVerifyCode(false);
  };

  return (
    <div className='retrieve-container'>
      <Tabs defaultActiveKey="1" onChange={onTabsChange} centered tabBarGutter={100} items={items} />
      <Form {...formItemLayout} form={form} name="retrieve" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ maxWidth: 600 }} scrollToFirstError className='retrieve-form'>
        {
          tabsId === '1' ? <Form.Item label={$t('Tel Account Login')} name="account" rules={[{ pattern: /^1[0-9]{10}$/, message: $t('Incorrect phone number format') }, { required: true, message: $t('Enter phone number') }]}>
            <Input placeholder={$t('Tel')} autoComplete="off" />
          </Form.Item> :
            <Form.Item name="email_account" label={$t('Enter email')} rules={[{ type: 'email', message: $t('Incorrect email format') }, { required: true, message: $t('Enter email') }]} >
              <Input placeholder={$t('Enter email')} autoComplete="off" />
            </Form.Item>
        }
        <Form.Item label={$t('Verification Code')} required>
          <Row gutter={8}>
            <Col span={18}>
              <Form.Item name="verify_code" noStyle rules={[{ required: true, message: $t('Verification Code') }]} >
                <Input placeholder={$t('Verification Code')} maxLength={6} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Button type='primary' block onClick={getRetrieveCode} disabled={isSendVerifyCode}>
                {isSendVerifyCode
                  ? <Statistic.Countdown valueStyle={{ fontSize: 14 }} value={Date.now() + 1000 * 60} format="ss" suffix={$t('Re-send the code')} onFinish={() => countDownFinish()} />
                  : $t('Get verification code')}
              </Button>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item
          name="new_password"
          label={$t('Password')}
          required
          rules={[{ min: 6, message: $t('Please Enter At Least 6 Characters') }, () => ({
            validator(_, value) {
              if (!value) {
                return Promise.reject($t('Password'));
              }
              const invalidChars = [...new Set(value.replace(/[A-Za-z0-9!@#$_\-*]/g, ''))];
              if (invalidChars.length > 0) {
                return Promise.reject(new Error($t('Invalid character: ') + invalidChars.join(' ')));
              }
              if (!(/^[A-Za-z0-9!@#$_*-]{6,16}$/.test(value) && [/[a-z]/, /[A-Z]/, /\d/, /[!@#$_*-]/].filter(r => r.test(value)).length >= 3)) {
                return Promise.reject(new Error($t('6-16 characters, must include letter, digit, and special character')));
              }
              return Promise.resolve();
            },
          }),
          ]}
        >
          <Input.Password placeholder={$t('6-16 characters, must include letter, digit, and special character')} maxLength={16} autoComplete="new-password" />
        </Form.Item>

        <Form.Item
          name="re_new_password"
          label={$t('Confirm Password')}
          required
          dependencies={['new_password']}
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value) {
                  return Promise.reject($t('Confirm Password'));
                }
                if (!value || getFieldValue('new_password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error($t('The two passwords do not match')));
              },
            }),
          ]}
        >
          <Input.Password placeholder={$t('Confirm Password')} maxLength={16} autoComplete="new-password" />
        </Form.Item>

        <Form.Item {...tailFormItemLayout} className='retrieve-button'>
          <Button type="primary" htmlType="submit">
            {$t('Reset Password')}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Retrieve;